export { default } from './Highlighter.js';
